import { DialogContext } from 'components';
import { useContext } from 'react';

function useDialog() {
  const { show } = useContext(DialogContext);
  return show;
}

export default useDialog;
